import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import arrow from '../../../assets/images/view-arrow.svg';
import masterCard from '../../../assets/images/master-card.svg';
import edit from '../../../assets/images/edit-pencil.svg';
import dot from '../../../assets/images/3dots.svg';
import down from '../../../assets/images/greydown-arrow.svg';
import { Link } from 'react-router-dom';
import { useHook as equipmentHook } from './useHook';
import useDebounce from '../../../components/Debounce';
import { useAlert } from '../../../components/Notification';
import { useSelector } from 'react-redux';
import { ReactComponent as SearchIcon } from '../../../assets/images/Search.svg';
import { Popup, Pagination, Unauthorized } from '../../../components/index';
import Download from '../../../assets/images/Download.svg';

const ManageBilling: React.FC<any> = () => {
  const showAlert = useAlert();
  const { invoiceList } = useSelector((state: any) => state.equipmetInfo);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState<string>('');
  const debouncedSearch = useDebounce(search, 1000);
  const [totalPages, setTotalPages] = useState(1);
  const { fetchGetInvoiceList } = equipmentHook();

  useEffect(() => {
    getData();
  }, []);
  //pagination
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    getData(page, rowsPerPage, search);
  };
  const handleRowsPerPageChange = (value: number) => {
    getData(1, value, search);
    setRowsPerPage(value);
    setCurrentPage(1);
  };

  //search
  const handleSearchChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const search = event.target.value;
    if (search !== '') {
      setSearch(search);
    } else {
      setSearch('');
    }
    if (!search) {
      getData(currentPage, rowsPerPage, search);
    }
  };
  useEffect(() => {
    if (debouncedSearch) {
      getData(1, rowsPerPage, search);
      setCurrentPage(1);
    }
  }, [debouncedSearch]);

  const getData = async (
    pagenumber?: number,
    row_perpage?: number,
    search: unknown = '',
    sort: { orderBy: string; order: number } = {
      orderBy: 'updatedAt',
      order: -1,
    },
  ) => {
    const payload = {
      sort: sort,
      search: search,
      limit: row_perpage ? row_perpage : rowsPerPage,
      offset: pagenumber
        ? (pagenumber - 1) * rowsPerPage
        : (currentPage - 1) * rowsPerPage,
    };

    await fetchGetInvoiceList(payload).then((res: any) => {
      const totalPage = res?.count
        ? Math.ceil(res?.count / (row_perpage ? row_perpage : rowsPerPage))
        : 1;
      setTotalPages(totalPage);
    });
  };
  interface InvoiceDetail {
    date: string;
    price: string;
    paid: string;
    premium: string;
  }

  const invoiceDetails: InvoiceDetail[] = [
    { date: 'Jun 3, 2024', price: '$0.00', paid: 'Paid', premium: 'Premium' },
    { date: 'Jun 3, 2024', price: '$0.00', paid: 'Paid', premium: 'Premium' },
    { date: 'Jun 3, 2024', price: '$0.00', paid: 'Paid', premium: 'Premium' },
  ];

  //formate date & time
  function formatTime(isoDate: string | Date): string {
    const date = new Date(isoDate);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
  }

  function formatDate(isoDate: string | Date) {
    const months = [
      'JAN',
      'FEB',
      'MAR',
      'APR',
      'MAY',
      'JUN',
      'JUL',
      'AUG',
      'SEP',
      'OCT',
      'NOV',
      'DEC',
    ];

    const date = new Date(isoDate);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  }

  return (
    // <div className="equipement-manage_billing">
    //   <div className="equipement-manage_billing-card">
    //     <div className="equipement-manage_billing-card_head">
    //       <h5 className="equipement-manage_billing-card_heading">
    //         Current Plan
    //       </h5>
    //     </div>
    //     <div className="equipement-manage_billing-card_body">
    //       <div className="equipement-manage_billing-card_body-head">
    //         <div className="manage_billing-card_body-head_content">
    //           <p className="manage_billing-card_body-head_content-para">
    //             premium
    //           </p>
    //           <h4 className="manage_billing-card_body-head_content-price">
    //             $0.00 per month
    //           </h4>
    //           <div className="manage_billing-card_body-head_content-details">
    //             <p className="manage_billing-card_body-head_content-para">
    //               View details
    //             </p>

    //             <img
    //               className="manage_billing-card_body-head_content-show"
    //               src={arrow}
    //               alt="view-icon"
    //             />
    //           </div>
    //           <p className="manage_billing-card_body-head_content-date">
    //             Your plan renews on July 3, 2024.
    //           </p>
    //         </div>
    //         <Button className="manage_billing-card_body-head_content-btn">
    //           Cancel plan
    //         </Button>
    //       </div>
    //       <div className="manage_billing-card_body-head">
    //         <img
    //           src={masterCard}
    //           alt=""
    //           className="manage_billing-card_body-head-img"
    //         />
    //         <p className="manage_billing-card_body-head_content-para">
    //           Mastercard •••• 9270
    //         </p>
    //         <img
    //           src={edit}
    //           alt=""
    //           className="manage_billing-card_body-foot-img"
    //         />
    //       </div>
    //     </div>
    //   </div>
    //   <div className="equipement-manage_billing-card">
    //     <div className="equipement-manage_billing-card_head">
    //       <h5 className="equipement-manage_billing-card_heading">
    //         Payment Method
    //       </h5>
    //       <Button className="equipement-manage_billing-card_head-btn">
    //         + Add payment method
    //       </Button>
    //     </div>
    //     <div className="manage_billing-card_body-head">
    //       <img
    //         src={masterCard}
    //         alt=""
    //         className="manage_billing-card_body-head-img"
    //       />
    //       <p className="manage_billing-card_body-head_content-para">
    //         Mastercard •••• 9270
    //       </p>
    //       <p className="manage_billing-card_body-head_content-para">
    //         Expires 08/2025
    //       </p>
    //       <img src={dot} alt="" className="manage_billing-card_body-foot-img" />
    //     </div>
    //   </div>
    //   <div className="equipement-manage_billing-card">
    //     <div className="equipement-manage_billing-card_head">
    //       <h5 className="equipement-manage_billing-card_heading">
    //         Billing Information
    //       </h5>
    //       <Link
    //         to={'/manageBilling'}
    //         className="equipement-manage_billing-card_head-btn "
    //       >
    //         Update information
    //       </Link>
    //     </div>
    //     <div className="equipement-manage_billing-card_body">
    //       <div className="manage_billing-info_cards">
    //         <div className="manage_billing-info_card">
    //           <p className="manage_billing-card_body-head_content-para">Name</p>
    //           <p className="manage_billing-card_body-head_content-para">
    //             Email
    //           </p>
    //           <p className="manage_billing-card_body-head_content-para">
    //             Billing address
    //           </p>
    //         </div>
    //         <div className="manage_billing-info_card">
    //           <p className="manage_billing-card_body-head_content-para">
    //             Jason Barrella
    //           </p>

    //           <p className="manage_billing-card_body-head_content-para">
    //             jason@mrgv.co
    //           </p>
    //           <p className="manage_billing-card_body-head_content-para">
    //             37876 US
    //           </p>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    //   <div className="equipement-manage_billing-card">
    //     <div className="equipement-manage_billing-card_head">
    //       <h5 className="equipement-manage_billing-card_heading">
    //         Invoice History
    //       </h5>
    //     </div>
    //     <div className="equipement-manage_billing-card_body">
    //       <div className="manage_billing-invoice-card-head">
    //         {invoiceDetails.map((item: InvoiceDetail, index: number) => (
    //           <div className="manage_billing-invoice-card" key={index}>
    //             <p className="manage_billing-card_body-head_content-para">
    //               {item.date}
    //             </p>
    //             <p className="manage_billing-card_body-head_content-para">
    //               {item.price}
    //             </p>
    //             <p className="manage_billing-invoice-card-paid">{item.paid}</p>
    //             <p className="manage_billing-card_body-head_content-para">
    //               {item.premium}
    //             </p>
    //           </div>
    //         ))}
    //       </div>
    //       <div className="manage_billing-invoice-card-foot">
    //         <img src={down} alt="icon" />
    //         <p className="manage_billing-card_body-head_content-date">
    //           View more
    //         </p>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <>
      <div className="content user_management">
        <div className="rolemanagement-header d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3">
          <div className="d-flex justify-content-center align-items-center">
            <div>
              <Typography variant="h5" className="h5 table-header">
                <b>Invoice History</b>
              </Typography>
              <Typography
                variant="body1"
                className="table-header-instruction m-0"
              ></Typography>
            </div>
          </div>

          <div className="table-header-btn">
            <TextField
              variant="outlined"
              placeholder="Search"
              onChange={handleSearchChange}
              InputProps={{
                startAdornment: <SearchIcon />,
              }}
              className="search-input"
            />
          </div>
        </div>

        <TableContainer component={Paper} className="controller_table ">
          <Table>
            <TableHead className="controller_tableheader">
              <TableRow>
                <TableCell>Equipment Name</TableCell>
                <TableCell>Invoice No</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Invoice Date</TableCell>
                <TableCell>download</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {invoiceList?.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={2}>
                    <Typography variant="body1" align="left">
                      No Data found
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                invoiceList &&
                invoiceList.map((invoice: any) => (
                  <TableRow key={invoice.invoiceID}>
                    <TableCell>
                      <p className="controller_management_model-data">
                        {invoice?.equipmentName || '-'}
                      </p>
                    </TableCell>
                    <TableCell>
                      <p className="controller_management_model-data">
                        {invoice?.invoiceNo || '-'}
                      </p>
                    </TableCell>
                    <TableCell>
                      <p className="controller_management_model-data">
                        {invoice?.amount
                          ? `${invoice?.amount?.toFixed(2)} ₹`
                          : '-'}
                      </p>
                    </TableCell>
                    <TableCell>
                      <p className="controller_management_model-data">
                        {formatDate(invoice.invoiceDate) +
                          ' ' +
                          formatTime(invoice.invoiceDate)}
                      </p>
                    </TableCell>
                    <TableCell className="customer_management-action">
                      <Link to={invoice?.link} target="blank">
                        <img src={Download} alt="arrow" width="20" />
                      </Link>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Pagination
          rowsPerPageOptions={[5, 10, 20, 30]}
          currentPage={currentPage}
          onPageChange={(page) => handlePageChange(page)}
          onRowsPerPageChange={handleRowsPerPageChange}
          totalPages={totalPages}
        />
      </div>
    </>
  );
};

export default ManageBilling;
